import { Component, ViewChild } from '@angular/core';
import { PivotBasePop } from './pivot-base.pop';
import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { WizCheckbox, WizDropItemEvent, WizRadioGroup } from '@wizeoo/akm-component-lib';
import { WIDGET_KIND } from '../../../../../model/enums';


@Component({
  // popUp d'édition du Pivot : gestion des emplacements de champs, formules d'aggrégats et rendu
  selector: 'pivot-extended-pop',
  templateUrl: './pivot-extended.pop.html',
})
export class PivotExtendedPop extends PivotBasePop {
  public popUpMode: WIDGET_KIND = WIDGET_KIND.PIVOT; // le mode de cette pop, pour alimenter les PKD

  /** choix de nommage des semaines */
  @ViewChild('rgMassEditConfig', { read: WizRadioGroup, static: false }) rgMassEditConfig: WizRadioGroup;

  @ViewChild('cbRevert', { read: WizCheckbox }) cbRevert: WizCheckbox; // inversion colonnes lignes

  /**
   * @override
   * sur séquence de démarrage, alimentation des listes avec leurs DS
   */
  public feedDatasources(): void {
    super.feedDatasources();
    this.rgMassEditConfig.wizValue = !!this.context.mem ? this.context.mem: 1;
    this.cbRevert.wizChecked = this.context?.revert;
    this.lstRow.dropControlFunction = this.rowOrColumnDropControl.bind(this);
    this.lstColumn.dropControlFunction = this.rowOrColumnDropControl.bind(this);
    this.lstData.dropControlFunction = this.dataDropControl.bind(this);
  }

  /** Fonction de controle du drop sur les clés d'aggregat : unicité sur row/column */
  public rowOrColumnDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    const field: PivotField = item.data as PivotField;

    let result: boolean = true;
    // if (!field.isKey) {
    //   // uniquement les Keys en aggrégat (pas les filters, juste les Keys)

    //   // Pivots sur measure éditables
    //   let meas: Measure = field.fkd.measure;
    //   if(meas.editable) {
    //     console.log('pivot on edit measure', meas);
    //     return true;
    //   }

    //   return false;
    // }

    if (dragSource === this.freeList || dragSource === this.lstFilter) {
      // seulement pour les pkd ou origine = filtre. Sinon, simple déplacement de rows vers cols
      this.rowDS.getSource().forEach((pkd: PivotField) => {
        // if (pkd.fullCode === field.fullCode) {
        //   result = false;
        // }
      });
      this.columnDS.getSource().forEach((pkd: PivotField) => {
        if (pkd.fullCode === field.fullCode) {
          result = false;
        }
      });
    }

    return result;
  }

  /** Fonction de controle du drop sur les datas : uniquement des mesures */
  public dataDropControl({ item }: WizDropItemEvent): boolean {
    // if (item.data.isKey && !item.data.isFilterKey) {
    //   return false;
    // }
    return true;
  }

  /** 
   * modification du context pour retour sur la base des params
   * @override
   */
  public updateContext(): void {
    super.updateContext();
    this.context.mem = this.rgMassEditConfig.wizValue; // affichage du delete
    this.context.revert = this.cbRevert.wizChecked;
  }


}
